/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsControllerListIntegrationsQueryResponse, IntegrationsControllerListIntegrationsPathParams } from "../../models/integrationsController/IntegrationsControllerListIntegrations";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { integrationsControllerListIntegrations } from "../../clients/integrationsService/integrationsControllerListIntegrations";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const integrationsControllerListIntegrationsQueryKey = (scopeId: IntegrationsControllerListIntegrationsPathParams["scopeId"]) => [{
  url: '/api/v1/integrations/:scopeId',
  params: {
    scopeId: scopeId
  }
}] as const;
export type IntegrationsControllerListIntegrationsQueryKey = ReturnType<typeof integrationsControllerListIntegrationsQueryKey>;
export function integrationsControllerListIntegrationsQueryOptions(scopeId: IntegrationsControllerListIntegrationsPathParams["scopeId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = integrationsControllerListIntegrationsQueryKey(scopeId);
  return queryOptions<IntegrationsControllerListIntegrationsQueryResponse, ResponseErrorConfig<Error>, IntegrationsControllerListIntegrationsQueryResponse, typeof queryKey>({
    enabled: !!scopeId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return integrationsControllerListIntegrations(scopeId, config);
    }
  });
}

/**
 * @summary List available providers and connected user integrations
 * {@link /api/v1/integrations/:scopeId}
 * @deprecated
 */
export function useIntegrationsControllerListIntegrations<TData = IntegrationsControllerListIntegrationsQueryResponse, TQueryData = IntegrationsControllerListIntegrationsQueryResponse, TQueryKey extends QueryKey = IntegrationsControllerListIntegrationsQueryKey>(scopeId: IntegrationsControllerListIntegrationsPathParams["scopeId"], options: {
  query?: Partial<QueryObserverOptions<IntegrationsControllerListIntegrationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? integrationsControllerListIntegrationsQueryKey(scopeId);
  const query = useQuery({
    ...integrationsControllerListIntegrationsQueryOptions(scopeId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}